import { render, staticRenderFns } from "./FormBasicDialogWrap.vue?vue&type=template&id=2a1357fa&scoped=true&"
import script from "./FormBasicDialogWrap.vue?vue&type=script&lang=ts&"
export * from "./FormBasicDialogWrap.vue?vue&type=script&lang=ts&"
import style0 from "./FormBasicDialogWrap.vue?vue&type=style&index=0&id=2a1357fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1357fa",
  null
  
)

export default component.exports